import { render, staticRenderFns } from "./allocationList.vue?vue&type=template&id=01572ae4&scoped=true&"
import script from "./allocationList.vue?vue&type=script&lang=js&"
export * from "./allocationList.vue?vue&type=script&lang=js&"
import style0 from "./allocationList.vue?vue&type=style&index=0&id=01572ae4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01572ae4",
  null
  
)

export default component.exports